"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * EMIL InsuranceService
 * The EMIL InsuranceService API description
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kontakt@emil.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductFactorsApi = exports.ProductFactorsApiFactory = exports.ProductFactorsApiFp = exports.ProductFactorsApiAxiosParamCreator = void 0;
var axios_1 = __importDefault(require("axios"));
// Some imports not used depending on template conditions
// @ts-ignore
var common_1 = require("../common");
// @ts-ignore
var base_1 = require("../base");
/**
 * ProductFactorsApi - axios parameter creator
 * @export
 */
var ProductFactorsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Retrieves the details of the product factor that was previously created.        Supply the unique product factor id that was returned when you created it and Emil Api will return the corresponding product factor information.
         * @summary Retrieve the product factor
         * @param {number} id
         * @param {number} id2 Internal unique identifier for the object. You should not have to use this, use code instead.
         * @param {string} [authorization] Bearer Token
         * @param {string} [expand] Fields to expand response by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductFactor: function (id, id2, authorization, expand, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, baseAccessToken, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('getProductFactor', 'id', id);
                            // verify required parameter 'id2' is not null or undefined
                            (0, common_1.assertParamExists)('getProductFactor', 'id2', id2);
                            localVarPath = "/insuranceservice/v1/product-factors/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                                baseAccessToken = configuration.accessToken;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            if (id2 !== undefined) {
                                localVarQueryParameter['id'] = id2;
                            }
                            if (expand !== undefined) {
                                localVarQueryParameter['expand'] = expand;
                            }
                            if (authorization !== undefined && authorization !== null || baseAccessToken !== undefined && baseAccessToken !== null) {
                                localVarHeaderParameter['Authorization'] = String(authorization ? authorization : baseAccessToken);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get the value corresponding to a specific product factor.
         * @summary Get product factor value
         * @param {number} productVersionId Product Version Id
         * @param {string} label Product factor label
         * @param {string} key Key for the product factor value
         * @param {string} name Name for the product factor value
         * @param {string} [authorization] Bearer Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductFactorValue: function (productVersionId, label, key, name, authorization, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, baseAccessToken, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'productVersionId' is not null or undefined
                            (0, common_1.assertParamExists)('getProductFactorValue', 'productVersionId', productVersionId);
                            // verify required parameter 'label' is not null or undefined
                            (0, common_1.assertParamExists)('getProductFactorValue', 'label', label);
                            // verify required parameter 'key' is not null or undefined
                            (0, common_1.assertParamExists)('getProductFactorValue', 'key', key);
                            // verify required parameter 'name' is not null or undefined
                            (0, common_1.assertParamExists)('getProductFactorValue', 'name', name);
                            localVarPath = "/insuranceservice/v1/product-factors/values";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                                baseAccessToken = configuration.accessToken;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            if (productVersionId !== undefined) {
                                localVarQueryParameter['productVersionId'] = productVersionId;
                            }
                            if (label !== undefined) {
                                localVarQueryParameter['label'] = label;
                            }
                            if (key !== undefined) {
                                localVarQueryParameter['key'] = key;
                            }
                            if (name !== undefined) {
                                localVarQueryParameter['name'] = name;
                            }
                            if (authorization !== undefined && authorization !== null || baseAccessToken !== undefined && baseAccessToken !== null) {
                                localVarHeaderParameter['Authorization'] = String(authorization ? authorization : baseAccessToken);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns product factors without values (values=none),     or with values if their number less or equal to 200 (values=short),     or with all values (values=all - this may take several seconds).
         * @summary List product factors for version
         * @param {number} productVersionId Unique identifier referencing the product Version.
         * @param {string} values Which values to return for every factor (None or Short for short value lists only or All).
         * @param {string} [authorization] Bearer Token
         * @param {boolean} [forPublic] true if this is a call from PublicAPI or false otherwise (default).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductFactorsForVersion: function (productVersionId, values, authorization, forPublic, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, baseAccessToken, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'productVersionId' is not null or undefined
                            (0, common_1.assertParamExists)('getProductFactorsForVersion', 'productVersionId', productVersionId);
                            // verify required parameter 'values' is not null or undefined
                            (0, common_1.assertParamExists)('getProductFactorsForVersion', 'values', values);
                            localVarPath = "/insuranceservice/v1/product-factors/for-version";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                                baseAccessToken = configuration.accessToken;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            if (productVersionId !== undefined) {
                                localVarQueryParameter['productVersionId'] = productVersionId;
                            }
                            if (values !== undefined) {
                                localVarQueryParameter['values'] = values;
                            }
                            if (forPublic !== undefined) {
                                localVarQueryParameter['forPublic'] = forPublic;
                            }
                            if (authorization !== undefined && authorization !== null || baseAccessToken !== undefined && baseAccessToken !== null) {
                                localVarHeaderParameter['Authorization'] = String(authorization ? authorization : baseAccessToken);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns a list of product factors you have previously created.        The product factors are returned in sorted order, with the oldest one appearing first.        For more information about pagination, read the Pagination documentation.
         * @summary List product factors
         * @param {string} [authorization] Bearer Token
         * @param {number} [pageSize] Page size.
         * @param {string} [pageToken] Page token.
         * @param {string} [filter] List filter
         * @param {string} [search] Search query.
         * @param {string} [order] Ordering criteria.
         * @param {string} [expand] Extra fields to fetch.
         * @param {string} [filters]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listProductFactors: function (authorization, pageSize, pageToken, filter, search, order, expand, filters, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, baseAccessToken, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/insuranceservice/v1/product-factors";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                                baseAccessToken = configuration.accessToken;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            if (pageSize !== undefined) {
                                localVarQueryParameter['pageSize'] = pageSize;
                            }
                            if (pageToken !== undefined) {
                                localVarQueryParameter['pageToken'] = pageToken;
                            }
                            if (filter !== undefined) {
                                localVarQueryParameter['filter'] = filter;
                            }
                            if (search !== undefined) {
                                localVarQueryParameter['search'] = search;
                            }
                            if (order !== undefined) {
                                localVarQueryParameter['order'] = order;
                            }
                            if (expand !== undefined) {
                                localVarQueryParameter['expand'] = expand;
                            }
                            if (filters !== undefined) {
                                localVarQueryParameter['filters'] = filters;
                            }
                            if (authorization !== undefined && authorization !== null || baseAccessToken !== undefined && baseAccessToken !== null) {
                                localVarHeaderParameter['Authorization'] = String(authorization ? authorization : baseAccessToken);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Upload a CSV file containing product factors necessary for a product.     The columns must be in the following order: group,label,key,name,value. It is advised to validate     the file first.
         * @summary Upload product factors
         * @param {string} [authorization] Bearer Token
         * @param {number} [productVersionId]
         * @param {any} [factors]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeProductFactors: function (authorization, productVersionId, factors, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, baseAccessToken, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarFormParams, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/insuranceservice/v1/product-factors";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                                baseAccessToken = configuration.accessToken;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            if (authorization !== undefined && authorization !== null || baseAccessToken !== undefined && baseAccessToken !== null) {
                                localVarHeaderParameter['Authorization'] = String(authorization ? authorization : baseAccessToken);
                            }
                            if (productVersionId !== undefined) {
                                localVarFormParams.append('productVersionId', productVersionId);
                            }
                            if (factors !== undefined) {
                                localVarFormParams.append('factors', factors);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = localVarFormParams;
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Validate a CSV file containing all product factors.     The columns must be in the following order: group,label,key,name,value.
         * @summary Validate product factors
         * @param {string} [authorization] Bearer Token
         * @param {any} [factors]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateProductFactors: function (authorization, factors, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, baseAccessToken, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarFormParams, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/insuranceservice/v1/product-factors/validate";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                                baseAccessToken = configuration.accessToken;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            if (authorization !== undefined && authorization !== null || baseAccessToken !== undefined && baseAccessToken !== null) {
                                localVarHeaderParameter['Authorization'] = String(authorization ? authorization : baseAccessToken);
                            }
                            if (factors !== undefined) {
                                localVarFormParams.append('factors', factors);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = localVarFormParams;
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.ProductFactorsApiAxiosParamCreator = ProductFactorsApiAxiosParamCreator;
/**
 * ProductFactorsApi - functional programming interface
 * @export
 */
var ProductFactorsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.ProductFactorsApiAxiosParamCreator)(configuration);
    return {
        /**
         * Retrieves the details of the product factor that was previously created.        Supply the unique product factor id that was returned when you created it and Emil Api will return the corresponding product factor information.
         * @summary Retrieve the product factor
         * @param {number} id
         * @param {number} id2 Internal unique identifier for the object. You should not have to use this, use code instead.
         * @param {string} [authorization] Bearer Token
         * @param {string} [expand] Fields to expand response by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductFactor: function (id, id2, authorization, expand, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getProductFactor(id, id2, authorization, expand, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get the value corresponding to a specific product factor.
         * @summary Get product factor value
         * @param {number} productVersionId Product Version Id
         * @param {string} label Product factor label
         * @param {string} key Key for the product factor value
         * @param {string} name Name for the product factor value
         * @param {string} [authorization] Bearer Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductFactorValue: function (productVersionId, label, key, name, authorization, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getProductFactorValue(productVersionId, label, key, name, authorization, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns product factors without values (values=none),     or with values if their number less or equal to 200 (values=short),     or with all values (values=all - this may take several seconds).
         * @summary List product factors for version
         * @param {number} productVersionId Unique identifier referencing the product Version.
         * @param {string} values Which values to return for every factor (None or Short for short value lists only or All).
         * @param {string} [authorization] Bearer Token
         * @param {boolean} [forPublic] true if this is a call from PublicAPI or false otherwise (default).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductFactorsForVersion: function (productVersionId, values, authorization, forPublic, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getProductFactorsForVersion(productVersionId, values, authorization, forPublic, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns a list of product factors you have previously created.        The product factors are returned in sorted order, with the oldest one appearing first.        For more information about pagination, read the Pagination documentation.
         * @summary List product factors
         * @param {string} [authorization] Bearer Token
         * @param {number} [pageSize] Page size.
         * @param {string} [pageToken] Page token.
         * @param {string} [filter] List filter
         * @param {string} [search] Search query.
         * @param {string} [order] Ordering criteria.
         * @param {string} [expand] Extra fields to fetch.
         * @param {string} [filters]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listProductFactors: function (authorization, pageSize, pageToken, filter, search, order, expand, filters, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.listProductFactors(authorization, pageSize, pageToken, filter, search, order, expand, filters, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Upload a CSV file containing product factors necessary for a product.     The columns must be in the following order: group,label,key,name,value. It is advised to validate     the file first.
         * @summary Upload product factors
         * @param {string} [authorization] Bearer Token
         * @param {number} [productVersionId]
         * @param {any} [factors]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeProductFactors: function (authorization, productVersionId, factors, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.storeProductFactors(authorization, productVersionId, factors, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Validate a CSV file containing all product factors.     The columns must be in the following order: group,label,key,name,value.
         * @summary Validate product factors
         * @param {string} [authorization] Bearer Token
         * @param {any} [factors]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateProductFactors: function (authorization, factors, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.validateProductFactors(authorization, factors, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.ProductFactorsApiFp = ProductFactorsApiFp;
/**
 * ProductFactorsApi - factory interface
 * @export
 */
var ProductFactorsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.ProductFactorsApiFp)(configuration);
    return {
        /**
         * Retrieves the details of the product factor that was previously created.        Supply the unique product factor id that was returned when you created it and Emil Api will return the corresponding product factor information.
         * @summary Retrieve the product factor
         * @param {number} id
         * @param {number} id2 Internal unique identifier for the object. You should not have to use this, use code instead.
         * @param {string} [authorization] Bearer Token
         * @param {string} [expand] Fields to expand response by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductFactor: function (id, id2, authorization, expand, options) {
            return localVarFp.getProductFactor(id, id2, authorization, expand, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get the value corresponding to a specific product factor.
         * @summary Get product factor value
         * @param {number} productVersionId Product Version Id
         * @param {string} label Product factor label
         * @param {string} key Key for the product factor value
         * @param {string} name Name for the product factor value
         * @param {string} [authorization] Bearer Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductFactorValue: function (productVersionId, label, key, name, authorization, options) {
            return localVarFp.getProductFactorValue(productVersionId, label, key, name, authorization, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns product factors without values (values=none),     or with values if their number less or equal to 200 (values=short),     or with all values (values=all - this may take several seconds).
         * @summary List product factors for version
         * @param {number} productVersionId Unique identifier referencing the product Version.
         * @param {string} values Which values to return for every factor (None or Short for short value lists only or All).
         * @param {string} [authorization] Bearer Token
         * @param {boolean} [forPublic] true if this is a call from PublicAPI or false otherwise (default).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductFactorsForVersion: function (productVersionId, values, authorization, forPublic, options) {
            return localVarFp.getProductFactorsForVersion(productVersionId, values, authorization, forPublic, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns a list of product factors you have previously created.        The product factors are returned in sorted order, with the oldest one appearing first.        For more information about pagination, read the Pagination documentation.
         * @summary List product factors
         * @param {string} [authorization] Bearer Token
         * @param {number} [pageSize] Page size.
         * @param {string} [pageToken] Page token.
         * @param {string} [filter] List filter
         * @param {string} [search] Search query.
         * @param {string} [order] Ordering criteria.
         * @param {string} [expand] Extra fields to fetch.
         * @param {string} [filters]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listProductFactors: function (authorization, pageSize, pageToken, filter, search, order, expand, filters, options) {
            return localVarFp.listProductFactors(authorization, pageSize, pageToken, filter, search, order, expand, filters, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Upload a CSV file containing product factors necessary for a product.     The columns must be in the following order: group,label,key,name,value. It is advised to validate     the file first.
         * @summary Upload product factors
         * @param {string} [authorization] Bearer Token
         * @param {number} [productVersionId]
         * @param {any} [factors]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeProductFactors: function (authorization, productVersionId, factors, options) {
            return localVarFp.storeProductFactors(authorization, productVersionId, factors, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Validate a CSV file containing all product factors.     The columns must be in the following order: group,label,key,name,value.
         * @summary Validate product factors
         * @param {string} [authorization] Bearer Token
         * @param {any} [factors]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateProductFactors: function (authorization, factors, options) {
            return localVarFp.validateProductFactors(authorization, factors, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.ProductFactorsApiFactory = ProductFactorsApiFactory;
/**
 * ProductFactorsApi - object-oriented interface
 * @export
 * @class ProductFactorsApi
 * @extends {BaseAPI}
 */
var ProductFactorsApi = /** @class */ (function (_super) {
    __extends(ProductFactorsApi, _super);
    function ProductFactorsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Retrieves the details of the product factor that was previously created.        Supply the unique product factor id that was returned when you created it and Emil Api will return the corresponding product factor information.
     * @summary Retrieve the product factor
     * @param {ProductFactorsApiGetProductFactorRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductFactorsApi
     */
    ProductFactorsApi.prototype.getProductFactor = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ProductFactorsApiFp)(this.configuration).getProductFactor(requestParameters.id, requestParameters.id2, requestParameters.authorization, requestParameters.expand, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get the value corresponding to a specific product factor.
     * @summary Get product factor value
     * @param {ProductFactorsApiGetProductFactorValueRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductFactorsApi
     */
    ProductFactorsApi.prototype.getProductFactorValue = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ProductFactorsApiFp)(this.configuration).getProductFactorValue(requestParameters.productVersionId, requestParameters.label, requestParameters.key, requestParameters.name, requestParameters.authorization, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns product factors without values (values=none),     or with values if their number less or equal to 200 (values=short),     or with all values (values=all - this may take several seconds).
     * @summary List product factors for version
     * @param {ProductFactorsApiGetProductFactorsForVersionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductFactorsApi
     */
    ProductFactorsApi.prototype.getProductFactorsForVersion = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ProductFactorsApiFp)(this.configuration).getProductFactorsForVersion(requestParameters.productVersionId, requestParameters.values, requestParameters.authorization, requestParameters.forPublic, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns a list of product factors you have previously created.        The product factors are returned in sorted order, with the oldest one appearing first.        For more information about pagination, read the Pagination documentation.
     * @summary List product factors
     * @param {ProductFactorsApiListProductFactorsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductFactorsApi
     */
    ProductFactorsApi.prototype.listProductFactors = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ProductFactorsApiFp)(this.configuration).listProductFactors(requestParameters.authorization, requestParameters.pageSize, requestParameters.pageToken, requestParameters.filter, requestParameters.search, requestParameters.order, requestParameters.expand, requestParameters.filters, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Upload a CSV file containing product factors necessary for a product.     The columns must be in the following order: group,label,key,name,value. It is advised to validate     the file first.
     * @summary Upload product factors
     * @param {ProductFactorsApiStoreProductFactorsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductFactorsApi
     */
    ProductFactorsApi.prototype.storeProductFactors = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ProductFactorsApiFp)(this.configuration).storeProductFactors(requestParameters.authorization, requestParameters.productVersionId, requestParameters.factors, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Validate a CSV file containing all product factors.     The columns must be in the following order: group,label,key,name,value.
     * @summary Validate product factors
     * @param {ProductFactorsApiValidateProductFactorsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductFactorsApi
     */
    ProductFactorsApi.prototype.validateProductFactors = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ProductFactorsApiFp)(this.configuration).validateProductFactors(requestParameters.authorization, requestParameters.factors, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ProductFactorsApi;
}(base_1.BaseAPI));
exports.ProductFactorsApi = ProductFactorsApi;
